import { type Html, html, UnsafeHtml, View } from 'rune-ts';
import klass from './Typo.module.scss';

export interface TypoData {
  text: number | string | Html | UnsafeHtml;
}

const TYPOGRAPH = {
  t1: klass.t1,
  t2: klass.t2,
  t3: klass.t3,
  t4: klass.t4,
  h1: klass.h1,
  h2: klass.h2,
  h3: klass.h3,
  p1: klass.p1,
  p2: klass.p2,
  p3: klass.p3,
  c1: klass.c1,
};

const WEIGHT = {
  regular: klass.regular,
  medium: klass.medium,
  bold: klass.bold,
};

const COLOR = {
  black: klass.black,
  white: klass.white,
  primary: klass.primary,
  secondary: klass.secondary,
  tertiary: klass.tertiary,
  success: klass.success,
  error: klass.error,
  accent: klass.accent,
  gray_80: klass.gray_80,
  gray_50: klass.gray_50,
  gray_20: klass.gray_20,
  gray_10: klass.gray_10,
  gray_5: klass.gray_5,
  gray_2_5: klass.gray_2_5,
};

const DECORATION = {
  underline: klass.underline,
  en: klass.en,
};

type TypoType<T> = {
  [K in keyof T]: string;
};

export interface TypoOption {
  typo?: keyof typeof TYPOGRAPH;
  color?: keyof typeof COLOR;
  weight?: keyof typeof WEIGHT;
  underline?: boolean;
  block?: boolean;
  tag?: string;
  need_en_font?: boolean;
  klass?: string;
}

export class Typo extends View<TypoData> {
  static typo: TypoType<typeof TYPOGRAPH> = TYPOGRAPH;
  static weight: TypoType<typeof WEIGHT> = WEIGHT;
  static deco: TypoType<typeof DECORATION> = DECORATION;
  static color: TypoType<typeof COLOR> = COLOR;

  constructor(
    data: TypoData,
    public option: TypoOption = { typo: 'p1' },
  ) {
    super(data);
  }

  private _makeKlass() {
    const { typo, need_en_font, color, underline, weight } = this.option;

    const klasses = [
      klass.typo,
      typo ? Typo.typo[typo] : klass.p1,
      underline ? Typo.deco.underline : false,
      color ? Typo.color[color] : false,
      need_en_font ? Typo.deco.en : false,
      weight ? Typo.weight[weight] : false,
      this.option.klass,
    ];

    return html`${klasses.filter(Boolean).join(' ')}`;
  }

  override template() {
    const { block, tag, typo } = this.option;
    if (tag) {
      return html`<${tag} class="${this._makeKlass()}">${this.data.text}</${tag}> `;
    }

    if (typo?.includes('h')) {
      return html`<${typo} class="${this._makeKlass()}">${this.data.text}</${typo}> `;
    }

    if (block) {
      return html`<div class="${this._makeKlass()}">${this.data.text}</div> `;
    }

    return html`<span class="${this._makeKlass()}">${this.data.text}</span> `;
  }
}
